import React from 'react';
import styled from 'styled-components';
import {
	colours,
	CardActions,
	CardButton,
	Card,
	H2,
	Subtitle2,
	breakpoints
} from '@sorted/sorted-ui';
import { CardContent } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

const CardTitle = styled(H2)`
	text-align: center;
	line-height: 1;
	margin-top: 20px;

	@media (max-width: ${breakpoints.smallDesktop}) {
		font-size: 28px;
	}

	@media (max-width: ${breakpoints.tablet}) {
		font-size: 20px;
		margin-top: 10px;
	}

	@media (max-width: ${breakpoints.mobile}) {
		font-size: 16px;
	}
`;

const CardDescription = styled(Subtitle2)`
	text-align: center;
	line-height: 1;
	margin-top: 10px;
	display: none;

	@media (min-width: ${breakpoints.smallDesktop}) {
		display: initial;
	}
`;

const StyledCardContent = withStyles(() => ({
	root: {
		height: '100%',
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		padding: 20
	}
}))(({ ...props }) => <CardContent {...props}>{props.children}</CardContent>);

const DefaultCard = withStyles(() => ({
	root: {
		width: '100%',
		backgroundColor: colours.cardTop,
		border: 'none',
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16) !important',
		display: 'flex',
		flexDirection: 'column',
		minHeight: 130
	}
}))(({ ...props }) => <Card {...props}>{props.children}</Card>);

const LandingPageCard = ({
	title,
	subtitle,
	icon,
	button = 'View',
	onClick
}) => {
	return (
		<DefaultCard elevation={3}>
			<StyledCardContent>
				{icon}
				<CardTitle>{title}</CardTitle>
				<CardDescription>{subtitle}</CardDescription>
			</StyledCardContent>

			<CardActions disableSpacing>
				<CardButton onClick={onClick}>{button}</CardButton>
			</CardActions>
		</DefaultCard>
	);
};

LandingPageCard.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	icon: PropTypes.element.isRequired,
	onClick: PropTypes.func.isRequired
};

export default LandingPageCard;
